<template>
  <div id="app" class="container">
    <!-- 路由占位符 -->
     <HeaderComponent class="header"></HeaderComponent>
    <router-view class="content"></router-view>
    <footerComponent></footerComponent>
  </div>
</template>
<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import footerComponent from '@/components/footerComponent.vue'


export default {
components: {
  HeaderComponent,
  footerComponent
}
}
</script>
<style >

* { font-family: Arial, sans-serif;margin: 0;padding: 0; }

</style>
